module.exports = __webpack_public_path__ + "img/planet.c3bf7361.png";